import { graphql } from "gatsby";
import React from "react";

import Layout from "../components/Layout/Layout";
import PostHeader from "../components/PostHeader/PostHeader";
import ContentBlocks from "../components/ContentBlocks/ContentBlocks";
import countWords from "../utils/postWordcount";
import featuredPostImage from "../utils/featuredPostImage";
import { TagsCard } from "../components/TagsCard/TagsCard";
import { RelatedContent } from "../components/RelatedContent/RelatedContent";
import SeoComponent from "../components/SeoComponent/SeoComponent";

import "@coopdigital/foundations/dist/vars/breakpoints.css";
import "./blogPost.css";

export const pageQuery = graphql`
  query BlogPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
    $categoryId: String!
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      title
      date(formatString: "DD MMMM YYYY")
      excerpt
      content
      blocks {
        tagName
        innerHtml
        type
        attributes {
          name
          value
        }
      }
      authorDetails {
        authorName
        authorRole
      }
      featuredImage {
        node {
          id
          sourceUrl
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
      categories {
        nodes {
          ancestors {
            nodes {
              id
              name
              link
            }
          }
          id
          name
          link
        }
      }
      tags {
        nodes {
          name
          slug
          uri
        }
      }
    }
    relatedContent: allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { id: { eq: $categoryId } } } }
        id: { ne: $id }
      }
      sort: { order: DESC, fields: date }
      limit: 3
    ) {
      nodes {
        id
        excerpt
        title
        uri
        slug
        featuredImage {
          node {
            id
            sourceUrl
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 980)
              }
            }
          }
        }
      }
    }
  }
`;

const BlogPostTemplate = ({ pageContext, data: { post, relatedContent } }) => {
  const pageCategory = pageContext.categoryName;
  const pageMedia = pageContext.mediaObject;

  return (
    <>
      <SeoComponent title={post.title} description={post.excerpt} />
      <Layout>
        <PostHeader
          title={post.title}
          date={post.date}
          author={post.authorDetails}
          categories={pageCategory}
          wordCount={countWords(post.content)}
          imageData={featuredPostImage(post.featuredImage)}
        />

        <div className="coop-l-container coop-u-padding-resp-t-64-48">
          <ContentBlocks blocks={post.blocks} mediaObject={pageMedia} />

          {post.tags.nodes.length > 0 && (
            <TagsCard tagsList={post.tags.nodes} />
          )}
        </div>
        {relatedContent.nodes.length > 0 && pageCategory && (
          <RelatedContent
            relatedContent={relatedContent}
            category={pageCategory}
          />
        )}
      </Layout>
    </>
  );
};

// propTypes

export default BlogPostTemplate;
